export const indexableTables = ["product", "post"] as const; // Order matters, it determines the order of search results when searching across multiple tables
